module.exports = __webpack_public_path__ + "static/85-a64bd0aae36ebfbee1a109c4c991e46c.png";